import React from "react"
//import components
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import CollectionsTable from "./CollectionsTable"
import { useTranslation } from "react-i18next"

export default function CollectionsList() {

  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Hours Collections")} />
        <CollectionsTable />
      </div>
    </div>
  )
}
